import { useState } from 'react';
import { usePreviewSitrepSection } from 'components/DisasterGPT/hooks/useSitrepsV2';
import {
  isDynamicSnapshotSection,
  showsDynamicSnapshotToggle,
  snapshotVersion,
  type DynamicSectionDataMode,
  type DynamicSnapshotSectionLike,
} from './dynamicSectionSnapshot';
import { useSitrepDynamicData } from './SitrepDynamicDataContext';

export function useDynamicSectionData(params: {
  section: DynamicSnapshotSectionLike;
  sitrepId: string;
  approvalStatus?: string | null;
}) {
  const reportMode = useSitrepDynamicData();
  const showToggle =
    isDynamicSnapshotSection(params.section) &&
    showsDynamicSnapshotToggle(params.approvalStatus, [params.section]);
  const [localMode, setLocalMode] = useState<DynamicSectionDataMode>('live');
  const ownsMode = Boolean(
    (params.section as { parent_section_id?: string | null }).parent_section_id
  );
  const followReport = Boolean(reportMode?.showTabs) && !ownsMode;
  const mode = followReport && reportMode ? reportMode.mode : localMode;
  const setMode =
    followReport && reportMode ? reportMode.setMode : setLocalMode;
  const frozen = snapshotVersion(params.section);
  const preview = usePreviewSitrepSection({
    sitrepId: params.sitrepId,
    sectionId: String(
      (params.section as { previewSectionId?: string }).previewSectionId ||
        (params.section as { id?: string }).id ||
        (params.section as { section_id?: string }).section_id ||
        ''
    ),
    enabled: showToggle && mode === 'live',
  });

  const dataString =
    showToggle && mode === 'live'
      ? preview.data?.data_string
      : showToggle
        ? frozen?.data_string
        : params.section.section_versions?.[0]?.data_string;

  return {
    showToggle,
    showLocalToggle: showToggle && (!reportMode?.showTabs || ownsMode),
    mode,
    setMode,
    dataString: dataString ?? null,
    useLiveEnrichment: !showToggle || mode === 'live',
    hideRun: showToggle,
    isPreviewLoading: showToggle && mode === 'live' && preview.isFetching,
    previewError: preview.error,
    refetchPreview: () => preview.refetch(),
  };
}
